import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store/store'

Vue.use(VueAxios, axios)

/**
 * Add backend api url from .env file
 */
axios.defaults.baseURL = process.env.BASE_API_URL


/**
 * Request interceptor that adds auth token to jwt requests
 */
axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + store.getters['auth/token']
    return config
  },
  error => Promise.reject(error => {
  })
)


axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.data.errors) {
      let err = ''
      for (let key in error.response.data.errors) {
        err += '- ' + error.response.data.errors[key] + ' '
      }
    }
    return Promise.reject(error)
  })



// WEBPACK FOOTER //
// ./src/axios.js